import React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import EngineeringIcon from '@mui/icons-material/Engineering';
import {signOut} from 'supertokens-auth-react/recipe/emailpassword';

const MaintenanceScreen = () => {
  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}>
      <Card sx={{maxWidth: 480, width: '100%'}}>
        <CardContent sx={{textAlign: 'center', py: 5}}>
          <Avatar sx={{bgcolor: 'warning.main', width: 64, height: 64, mx: 'auto', mb: 2}}>
            <EngineeringIcon fontSize='large' />
          </Avatar>
          <Typography variant='h5' gutterBottom>
            Wartungsarbeiten
          </Typography>
          <Typography color='text.secondary' sx={{mb: 4}}>
            Die Anwendung wird gerade aktualisiert und ist vorübergehend nicht verfügbar. Bitte
            versuchen Sie es später erneut.
          </Typography>
          <Stack direction='row' spacing={2} justifyContent='center'>
            <Button variant='outlined' onClick={() => window.location.reload()}>
              Erneut versuchen
            </Button>
            <Button variant='contained' onClick={handleSignOut}>
              Abmelden
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MaintenanceScreen;
